@if (regions && sources && basecases && subtypes) {
  <div class="flex-container-inline">
    <div class="advanced-mode-toggle">
      <tds-toggle [checked]="advancedMode()" (checkedChange)="toggleAdvancedMode($event)"
        >Advanced</tds-toggle
      >
    </div>

    <form class="sidenav-content" [formGroup]="searchScenariosForm">
      <div class="flex">
        <mat-form-field appearance="outline" data-testid="market-area-select-input">
          <mat-label
            ><app-info-icon-tooltip
              text="Market Area groups price zones by geography."
            ></app-info-icon-tooltip>
            Market Area</mat-label
          >
          <mat-select
            formControlName="marketAreaIds"
            multiple
            (selectionChange)="retrievereFilteredReferentialsIds(Filters.MARKET_AREA)"
          >
            @for (area of availableMarketAreas(); track area.id) {
              <mat-option [value]="area.id">{{ area.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <div class="w-10"></div>
      </div>
      <div class="flex">
        <mat-form-field appearance="outline" data-testid="regions-select-input">
          <mat-label
            ><app-info-icon-tooltip
              text="Price zone could be a country, a bidding zone, a hub, a load zone, a node."
            ></app-info-icon-tooltip>
            Price Zone</mat-label
          >
          <mat-select
            formControlName="zoneIds"
            multiple
            (selectionChange)="retrievereFilteredReferentialsIds(Filters.REGION)"
          >
            @for (region of displayedRegions(); track region.id) {
              <mat-option [value]="region.id">{{ region.name }} - {{ region.alias }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <app-chart-markers
          targetedFieldName="zone"
          [targetedFieldValues]="chartMarkers().zone"
        ></app-chart-markers>

        @if (!advancedMode()) {
          <div class="w-5"></div>
        }
      </div>
      <div class="flex">
        <mat-form-field appearance="outline" data-testid="sources-select-input">
          <mat-label
            ><app-info-icon-tooltip
              text="Source is the publisher of the data. It could be internal or external and the use of the data can be subject to specific rules. Select 'LT Internal Ref'. if you want internal scenarios to be used for investment economics in your Dossier."
            ></app-info-icon-tooltip>
            Source</mat-label
          >
          <mat-select
            formControlName="sourceIds"
            multiple
            (selectionChange)="onSourceSelectionChange()"
          >
            @for (sourcesGroup of sourcesGroupedByCategory; track sourcesGroup.category) {
              <mat-optgroup [label]="sourcesGroup.category">
                @for (source of sourcesGroup.sources; track source) {
                  <mat-option [value]="source.id">{{ source.name }}</mat-option>
                }
              </mat-optgroup>
            }
          </mat-select>
        </mat-form-field>
        <app-chart-markers
          targetedFieldName="source"
          [targetedFieldValues]="chartMarkers().source"
        ></app-chart-markers>

        @if (!advancedMode()) {
          <div class="w-5"></div>
        }
      </div>

      <div class="flex">
        <mat-form-field appearance="outline" data-testid="basecases-select-input">
          <mat-label
            ><app-info-icon-tooltip
              text="Scenario represent the different results of the modeling done by the Source, depending on different set of Inputs. Select 'All basecases' if you want to retrieve all the 'P50' scenarios from all the Sources."
            ></app-info-icon-tooltip>
            Scenario</mat-label
          >
          <mat-select
            [value]="getSelectedBasecaseGroupNames()"
            multiple
            (selectionChange)="onBasecaseGroupSelectionChange($event.value)"
          >
            @for (group of basecaseGroups; track group.name) {
              <mat-option [value]="group.name">{{ group.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <div class="w-10"></div>
      </div>

      <div class="flex">
        <mat-form-field appearance="outline" data-testid="subtype-select-input">
          <mat-label
            ><app-info-icon-tooltip
              text="As the price you will download are averages, you need to select the shape of the technology which will be the closest to your project, so you can download baseload prices and captured prices."
            ></app-info-icon-tooltip>
            Baseload / Captured</mat-label
          >
          <mat-select
            formControlName="subtypeIds"
            multiple
            (selectionChange)="retrievereFilteredReferentialsIds(Filters.SUBTYPE)"
          >
            @for (subtype of filteredSubtypes; track subtype) {
              <mat-option [value]="subtype.id">{{ subtype.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <div class="w-10"></div>
      </div>

      @if (advancedMode()) {
        <mat-divider class="divider"></mat-divider>
        <div class="flex">
          <mat-form-field
            appearance="outline"
            data-testid="subtype-select-input"
            class="psf-fade-in-animation-300"
          >
            <mat-label
              ><app-info-icon-tooltip
                text="Select the granularity of the dataset you want to retrieve."
              ></app-info-icon-tooltip>
              Granularity</mat-label
            >
            <mat-select formControlName="granularity">
              @for (granularity of Granularities; track granularity) {
                <mat-option [value]="granularity">
                  {{ granularity | titlecase }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <div class="w-10"></div>
        </div>
        <div class="flex">
          <mat-form-field
            appearance="outline"
            data-testid="subtype-select-input"
            class="psf-fade-in-animation-300"
          >
            <mat-label
              ><app-info-icon-tooltip
                text="Weather year, corresponds to the weather pattern, (historical or modeled), that is use to run the simulation. Thus, taking into account the correlations between temperature, solar irradiation, wind speed, rain and snow."
              ></app-info-icon-tooltip>
              Weather Year</mat-label
            >
            <mat-select
              formControlName="weatherYearIds"
              multiple
              (selectionChange)="retrievereFilteredReferentialsIds(Filters.WEATHER_YEAR)"
            >
              @for (year of filteredWeatherYears; track year) {
                <mat-option [value]="year.id">{{ year.name | titlecase }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <div class="w-10"></div>
        </div>
        <div class="flex">
          <mat-form-field appearance="outline" class="psf-fade-in-animation-300">
            <mat-label
              ><app-info-icon-tooltip
                text="Select 'Last release' if you want the last available scenarios for each Source or Price zone."
              ></app-info-icon-tooltip>
              Release</mat-label
            >
            <mat-select
              formControlName="publicationDateType"
              (selectionChange)="publicationDateTypeChange($event.value)"
            >
              <mat-option></mat-option>
              <mat-option value="1">Last Release</mat-option>
              <mat-option value="2">2 Last Releases</mat-option>
              <mat-option value="3">Between Range</mat-option>
            </mat-select>
          </mat-form-field>
          <div class="w-10"></div>
        </div>
        <div class="flex">
          <mat-form-field appearance="outline" class="psf-fade-in-animation-300">
            <mat-label>Release</mat-label>
            <mat-date-range-input [rangePicker]="picker" class="psf-mat-datepicker">
              <input
                id="search-scenarios-start-date"
                matStartDate
                formControlName="startPublicationDate"
                placeholder="Start date"
                aria-label="Start date"
              />
              <input
                id="search-scenarios-end-date"
                matEndDate
                formControlName="endPublicationDate"
                placeholder="End date"
                aria-label="End date"
              />
            </mat-date-range-input>
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>
          <div class="w-10"></div>
        </div>
      }
    </form>

    <div class="sidenav-footer">
      <button
        tds-button
        size="lg"
        variant="primary"
        (click)="searchScenarios()"
        data-testid="search-scenarios-button"
        class="search-button"
      >
        Apply filters
      </button>
      <button
        tds-button
        variant="tertiary"
        (click)="clearAllFilters()"
        data-testid="search-scenarios-button"
        class="clear-button"
        name="info"
        matTooltip="Clear search filters"
        matTooltipPosition="right"
        matTooltipShowDelay="500"
        matTooltipHideDelay="500"
      >
        <tds-icon name="close" />
        <span>Clear</span>
      </button>
    </div>
  </div>
}
